module.exports = __webpack_public_path__ + "static/media/badge_health_2.5875a460.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_health_2.png
// module id = 498
// module chunks = 0